import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { seedDevOidcUserIfMissing } from './utils/devMode'
import { TEAMS_AUTH_IN_PROGRESS_KEY } from './utils/teamsAuthFlow'
import { markTeamsSession, clearTeamsSession } from './utils/teamsSession'
import { isTeamsHost } from './utils/teamsHost'
import { installEarlyTeamsLinkCapture } from './utils/teamsLinkCaptureBoot'
import {
  getOidcAuthority,
  getOidcClientId,
  getOidcRedirectUri,
  getOidcScope,
  migrateLegacyOidcUserStorage,
} from './utils/oidcConfig'

migrateLegacyOidcUserStorage()
seedDevOidcUserIfMissing()

const _params = new URLSearchParams(window.location.search);
const _teamsParam = _params.get('teams') === 'true';
const _authInProgress = Boolean(sessionStorage.getItem(TEAMS_AUTH_IN_PROGRESS_KEY));

if (isTeamsHost() || _authInProgress) {
  // Confirmed Teams iframe or mid-SSO: cement the session.
  markTeamsSession()
} else if (!_teamsParam) {
  // Definitively a plain browser tab with no Teams signals — purge any stale session flag
  // that may have been written by a previous visit with ?teams=true or the old buggy code.
  clearTeamsSession()
}

installEarlyTeamsLinkCapture()

const origin = window.location.origin;
const OATH_CONFIG = {
  authority: getOidcAuthority(),
  client_id: getOidcClientId(),
  redirect_uri: getOidcRedirectUri(origin),
  popup_redirect_uri: getOidcRedirectUri(origin),
  // silent_redirect_uri omitted — oidc-client-ts defaults to redirect_uri (/callback, already registered).
  response_type: "code",
  scope: getOidcScope(),
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    // Keep SPA on /callback until TeamsAuthCallbackPage finishes notifySuccess / deeplink.
    if (sessionStorage.getItem(TEAMS_AUTH_IN_PROGRESS_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const suffix = params.get('teams') === 'true' ? '?teams=true' : '';
    window.history.replaceState({}, document.title, `${window.location.pathname}${suffix}`);
  },
  // ZoomInfo returns ?code=&state= on its own callback. Do not redeem that as ConnectWise SSO.
  skipSigninCallback: window.location.pathname.startsWith('/zoominfo/callback'),
}

console.log('OIDC Config:', OATH_CONFIG);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider  {...OATH_CONFIG}>
      <App />
    </AuthProvider>
  </React.StrictMode>
)
